require("jquery-ui/ui/widgets/autocomplete.js");
function PropertyAutoComplete() {    
    $(function () {
        var propertyid = $("#PropertyId").val();
        var locationid = $("#locationsDropdown").val();

        $("#propertySearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "propertySearch",
                    type: "POST",
                    dataType: "json",
                    data: { propertySearch: request.term },
                    success: function (data) {
                        $("#PropertyId").val('0');
                        response($.map(data, function (item) {                            
                            return { label: item.name , value: item.propertyId };
                        }))
                    }
                })
            },
            select: function (event, ui) {  
                $("#PropertyId").val(ui.item.value);
                $("#propertySearch").val(ui.item.label);

                PopulateLocationDropdown(ui.item.value);
                return false;
            }
        });

      


        $("#locationsDropdown").change(function () {
            $("#LocationId").val($(this).val());
        });

        function clearLocation() {
            $('#LocationId').val('');
            $("#locationsDropdown").empty();
        }

        function clearProperty() {
            $('#PropertyId').val('');
            $('#propertySearch').val('');
        }

        $('#assetClearButton').on('click', function (event) {
            $('#assetSearch').val('');
        });

        $('.clearButton').on('click', function (event) {
            event.stopPropagation();
            var inputContainer = $(this).closest('.input-group');
            var inputElement = inputContainer.find('input, select');

            if (inputElement.is('input')) {
                if (inputElement.attr('id') === "propertySearch") {
                    clearProperty();
                    clearLocation();
                }
            } else if (inputElement.is('select')) {
                clearLocation();
            }
        });

    });
}

function PopulateLocationDropdown(propId, locId) {
    $.ajax({
        type: "GET",
        url: "LocationFilter",
        data: { propertyId: propId },
        success: function (data) {
            var s = '<option value="0">Please Select a Location</option>';
            for (var i = 0; i < data.length; i++) {
                s += '<option value="' + data[i].id + '">' + data[i].path + '</option>';
            }
            $("#locationsDropdown").html(s);
            if (locId != 0 && locId != "") {
                $('#locationsDropdown option[value="' + locId + '"]').attr("selected", "selected");
            }
        }
    });
}

module.exports = { PropertyAutoComplete, PopulateLocationDropdown };
